const { accordionWrapperProperties } = require("../AccordionWrapper/AccordionWrapper.query")

const query = (id, isPreview) => `
{
  trendRadarChart (id: "${id}", preview: ${isPreview}) {
    heading
    description
    config
    variant
    content{
      ${accordionWrapperProperties}
    }
  }
}
`

module.exports = { query }